import { Auth } from "aws-amplify";

const AuthService = {
    async login(params) {
        return await Auth.signIn(params.username, params.password)
    },

    get Token() {
        return Auth.currentSession().then(data => {
            return {
                token: data.accessToken.jwtToken,
            }
        }).catch(error => {
            if (process.env.NODE_ENV == "test") {
                return {
                    token: 'sfsfsdfdsfsf',
                }
            }
            else if (error) {
                return null;
            }
            else {
                return null;
            }
        })
    },
    async signOut() {
        await Auth.signOut();
    },
    updatePassword(userObject, password) {
        return Auth.completeNewPassword(userObject, password)
    },
    saveAuthData(name, value) {
        window.sessionStorage.setItem(name, value)
    }
}

export default AuthService